// extracted by mini-css-extract-plugin
module.exports = {"busy":"team_gatekeeper_busy__1Vdfd","view":"team_gatekeeper_view__3dNFx","icon":"team_gatekeeper_icon__32-XU","title":"team_gatekeeper_title__1pOqS"};